<template>
  <div class="overview-page">
    <h1 class="page-title">後臺帳號列表</h1>
    <v-container>
      <!-- 篩選條 -->
      <v-card class="filter-card">
        <v-row class="filter-row" align="center">
          <v-col cols="12" sm="6" md="2">
            <v-text-field v-model="filters.user" label="使用者帳號" outlined dense hide-details
              class="custom-field"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <VueDatePicker v-model="filters.createdDateRange" range locale="zh" :format="formatRange"
              placeholder="建立日期範圍" type="date" :enable-time="false" :show-action-buttons="false" class="custom-field"
              teleport="body" />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <VueDatePicker v-model="filters.modifiedDateRange" range locale="zh" :format="formatRange"
              placeholder="修改日期範圍" type="date" :enable-time="false" :show-action-buttons="false" class="custom-field"
              teleport="body" />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filters.status" :items="statuses" label="狀態" outlined dense hide-details
              class="custom-select"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select v-model="filters.role" :items="roles" label="角色" outlined dense hide-details
              class="custom-select"></v-select>
          </v-col>
        </v-row>

        <!-- 按鈕區域 -->
        <v-row class="filter-actions" align="center" justify="end">
          <v-btn outlined color="primary" class="action-btn" @click="clearFilters">清除</v-btn>
          <v-btn outlined color="secondary" class="action-btn ml-2" @click="applyFilters">搜尋</v-btn>
        </v-row>
      </v-card>

      <!-- 資料表 -->
      <v-card class="table-card">
        <!-- 新增帳號按鈕 -->
        <div class="table-header-row">
          <v-btn class="add-account-btn" color="primary" @click="openAddAccountDialog">
            <v-icon left>mdi-plus</v-icon>新增帳號
          </v-btn>

        </div>
        <table class="custom-table">
          <thead>
            <tr>
              <th v-for="header in headers" :key="header.value" class="table-header sortable-header"
                @click="header.value !== 'action' && sortTable(header.value)">
                {{ header.text }}
                <v-icon small v-if="header.value !== 'action'">{{ getSortIcon(header.value) }}</v-icon>
              </th>
              <th class="table-header actions-column">操作</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in filteredItems" :key="index">
              <td>{{ item.user }}</td>
              <td>{{ item.createdDate }}</td>
              <td>{{ item.modifiedDate }}</td>
              <td>{{ item.status }}</td>
              <td>{{ item.role }}</td>
              <td class="actions-cell">
                <v-icon small class="action-icon" @click="viewItem(item)">mdi-eye</v-icon>
                <v-icon small class="action-icon" @click="editItem(item)">mdi-pencil</v-icon>
              </td>
            </tr>
          </tbody>
        </table>
      </v-card>
    </v-container>
    <v-dialog v-model="viewDialog" max-width="500px">
      <v-card>
        <v-card-title class="dialog-title">
          <v-icon small class="title-icon">mdi-eye</v-icon> 檢視帳號資料
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-content">
          <v-row>
            <v-col cols="4" class="label-cell">使用者帳號:</v-col>
            <v-col cols="8">{{ selectedItem.user }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="label-cell">建立日期:</v-col>
            <v-col cols="8">{{ selectedItem.createdDate }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="label-cell">修改日期:</v-col>
            <v-col cols="8">{{ selectedItem.modifiedDate }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="label-cell">狀態:</v-col>
            <v-col cols="8">{{ selectedItem.status }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="label-cell">角色:</v-col>
            <v-col cols="8">{{ selectedItem.role }}</v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="primary" @click="closeViewDialog">關閉</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title class="dialog-title">
          <v-icon small class="title-icon">mdi-pencil</v-icon> 編輯帳號資料
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-content">
          <v-row>
            <v-col cols="4" class="label-cell">
              <label for="user-account">使用者帳號:</label>
            </v-col>
            <v-col cols="8">
              <v-text-field id="user-account" v-model="selectedItem.user" outlined dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="label-cell">
              <label for="created-date">建立日期:</label>
            </v-col>
            <v-col cols="8">
              <v-text-field id="created-date" v-model="selectedItem.createdDate" outlined dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="label-cell">
              <label for="modified-date">修改日期:</label>
            </v-col>
            <v-col cols="8">
              <v-text-field id="modified-date" v-model="selectedItem.modifiedDate" outlined dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="label-cell">
              <label for="status">狀態:</label>
            </v-col>
            <v-col cols="8">
              <v-select id="status" v-model="selectedItem.status" :items="statuses" outlined dense></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="label-cell">
              <label for="role">角色:</label>
            </v-col>
            <v-col cols="8">
              <v-select id="role" v-model="selectedItem.role" :items="roles" outlined dense></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="primary" @click="saveItem">保存</v-btn>
          <v-btn text color="secondary" @click="closeEditDialog">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addAccountDialog" max-width="600px">
      <v-card>
        <v-card-title class="dialog-title">
          <v-icon small class="title-icon">mdi-plus</v-icon> 新增帳號
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-content">
          <v-row>
            <v-col cols="4" class="label-cell">使用者帳號</v-col>
            <v-col cols="8">
              <v-text-field v-model="newAccount.user" outlined dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="label-cell">狀態</v-col>
            <v-col cols="8">
              <v-select v-model="newAccount.status" :items="statuses" outlined dense></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="label-cell">角色</v-col>
            <v-col cols="8">
              <v-select v-model="newAccount.role" :items="roles" outlined dense></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="primary" @click="saveNewAccount">保存</v-btn>
          <v-btn text color="secondary" @click="closeAddAccountDialog">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";


export default {
  name: "userAccounts",
  components: { VueDatePicker },
  data() {
    return {
      statuses: ["啟用", "禁用"],
      roles: ["管理員", "使用者"],
      headers: [
        { text: "使用者帳號", value: "user" },
        { text: "建立日期", value: "createdDate" },
        { text: "修改日期", value: "modifiedDate" },
        { text: "狀態", value: "status" },
        { text: "角色", value: "role" },
      ],
      filters: {
        user: "",
        createdDateRange: [],
        modifiedDateRange: [],
        status: null,
        role: null,
      },
      sortKey: "", // 當前排序的欄位
      sortOrder: "asc", // 排序方式（"asc" 或 "desc"）
      viewDialog: false,
      editDialog: false,
      addAccountDialog: false, // 控制新增帳號對話框
      newAccount: {
        user: "",
        createdDate: "",
        modifiedDate: "",
        status: "",
        role: "",
      },
      items: [
        {
          user: "user1",
          createdDate: "2024-12-25",
          modifiedDate: "2024-12-26",
          status: "啟用",
          role: "管理員",
        },
        {
          user: "user2",
          createdDate: "2024-11-20",
          modifiedDate: "2024-11-25",
          status: "禁用",
          role: "使用者",
        },
        {
          user: "user3",
          createdDate: "2024-12-20",
          modifiedDate: "2024-12-23",
          status: "啟用",
          role: "使用者",
        },
        {
          user: "user4",
          createdDate: "2024-10-15",
          modifiedDate: "2024-10-16",
          status: "禁用",
          role: "管理員",
        },
      ],
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter((item) => {
        const matchesUser = !this.filters.user || item.user.includes(this.filters.user);
        const matchesStatus = !this.filters.status || item.status === this.filters.status;
        const matchesRole = !this.filters.role || item.role === this.filters.role;

        const matchesCreatedDate =
          Array.isArray(this.filters.createdDateRange) &&
            this.filters.createdDateRange.length === 2
            ? new Date(item.createdDate).getTime() >=
            new Date(this.filters.createdDateRange[0]).setHours(0, 0, 0, 0) &&
            new Date(item.createdDate).getTime() <=
            new Date(this.filters.createdDateRange[1]).setHours(23, 59, 59, 999)
            : true;

        const matchesModifiedDate =
          Array.isArray(this.filters.modifiedDateRange) &&
            this.filters.modifiedDateRange.length === 2
            ? new Date(item.modifiedDate).getTime() >=
            new Date(this.filters.modifiedDateRange[0]).setHours(0, 0, 0, 0) &&
            new Date(item.modifiedDate).getTime() <=
            new Date(this.filters.modifiedDateRange[1]).setHours(23, 59, 59, 999)
            : true;

        return matchesUser && matchesStatus && matchesRole && matchesCreatedDate && matchesModifiedDate;
      });
    },
  },

  methods: {
    
    sortTable(key) {
      if (key === "action") return; // 跳過操作欄排序
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }

      this.items.sort((a, b) => {
        let valueA = a[key];
        let valueB = b[key];

        // 日期排序
        if (key === "createdDate" || key === "modifiedDate") {
          valueA = new Date(valueA).getTime();
          valueB = new Date(valueB).getTime();
          return this.sortOrder === "asc" ? valueA - valueB : valueB - valueA;
        }

        // 字串排序
        if (typeof valueA === "string" && typeof valueB === "string") {
          return this.sortOrder === "asc"
            ? valueA.localeCompare(valueB)
            : valueB.localeCompare(valueA);
        }

        return this.sortOrder === "asc" ? valueA - valueB : valueB - valueA;
      });
    },

    getSortIcon(key) {
      if (this.sortKey !== key) return "mdi-swap-vertical"; // 未排序圖標
      return this.sortOrder === "asc" ? "mdi-arrow-up" : "mdi-arrow-down"; // 升序或降序圖標
    },
    formatRange(range) {
      if (!range || range.length !== 2) return "";
      const [start, end] = range;
      return `${start.toISOString().split("T")[0]} ~ ${end.toISOString().split("T")[0]}`;
    },
    clearFilters() {
      this.filters = {
        user: "",
        createdDateRange: [],
        modifiedDateRange: [],
        status: null,
        role: null,
      };
    },
    applyFilters() {
      console.log("Filters applied:", this.filters);
    },
    openAddAccountDialog() {
    this.addAccountDialog = true;
  },
  closeAddAccountDialog() {
    this.addAccountDialog = false;
  },
  saveNewAccount() {
    if (this.newAccount.user && this.newAccount.status && this.newAccount.role) {
      this.items.push({ ...this.newAccount }); // 新增到資料表
      this.newAccount = { user: "", createdDate: "", modifiedDate: "", status: "", role: "" }; // 重置表單
      this.addAccountDialog = false; // 關閉對話框
      console.log("新增成功:", this.newAccount);
    } else {
      console.error("表單未填寫完整");
    }
  },
    viewItem(item) {
      this.selectedItem = { ...item }; // 深拷貝選中的數據
      this.viewDialog = true; // 打開檢視對話框
    },
    closeViewDialog() {
      this.viewDialog = false; // 關閉檢視對話框
    },
    editItem(item) {
      this.selectedItem = { ...item }; // 深拷貝選中數據
      this.editDialog = true; // 顯示編輯對話框
    },
    saveItem() {
      const index = this.items.findIndex(
        (i) => i.user === this.selectedItem.user
      );
      if (index !== -1) {
        this.items.splice(index, 1, { ...this.selectedItem }); // 更新數據
      }
      this.editDialog = false; // 關閉對話框
      console.log("保存成功:", this.selectedItem);
    },
    closeEditDialog() {
      this.editDialog = false; // 關閉編輯對話框
    },
  },
};
</script>

<style scoped>
.table-header {
  background-color: #333333;
  color: white;
  font-weight: bold;
  padding: 10px;
  cursor: pointer;
}

/* 頁面樣式 */
.overview-page {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 20px;
}

.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

/* 篩選條樣式 */
.filter-card {
  padding: 16px;
  margin-bottom: 20px;
  border-radius: 8px;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.filter-row {
  margin-bottom: 16px;
}

.custom-field,
.custom-select {
  font-size: 14px;
}

/* 表格樣式 */
.table-card {
  padding: 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.table-header-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.add-account-btn {
  text-transform: none;
  font-weight: bold;
}

/* 表格樣式 */
.custom-table {
  width: 100%;
  border-collapse: collapse;
}

.custom-table th {
  background-color: #333;
  color: white;
  font-weight: bold;
  text-align: center;
  /* 將欄名文字置中 */
  vertical-align: middle;
  /* 垂直置中 */
  padding: 10px;
}

.custom-table td {
  padding: 8px;
  border-bottom: 1px solid #ddd;
  text-align: center;
  /* 將表格內容文字置中 */
  vertical-align: middle;
  /* 垂直置中 */
}

.actions-cell {
  display: flex;
  gap: 8px;
  justify-content: center;
  /* 水平置中 */
  align-items: center;
  /* 垂直置中 */
}


.action-icon {
  cursor: pointer;
  color: #666;
}

.action-icon:hover {
  color: #333;
}

.dialog-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}

.label-cell {
  font-weight: bold;
  display: flex;
  align-items: center;
}

.dialog-content {
  background-color: #fff;
  padding: 16px;
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
}
</style>
